import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function isGroupsEnabled() {
    const userConfiguration = getUserConfiguration();
    return userConfiguration.GroupsEnabled && !userConfiguration.SessionSettings.IsExplicitLogon;
}
